import { Avatar } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import { fullName, getImageFromUrl } from 'crono-fe-common/utils';
import { stringAvatarProspect } from 'utils/formatUtils';

export const CalleeInfo = ({
  callee,
  callStatusText,
}: {
  callee: {
    firstName?: string;
    lastName?: string;
    phoneNumber: string;
    website?: string;
  };
  callStatusText: string;
}) => {
  return (
    <div className="relative flex flex-col items-center">
      <div className="relative">
        <Avatar
          sx={{
            width: 80,
            height: 80,
            color: colors.primary,
            backgroundColor: colors.primaryLight,
            fontSize: 30,
            border: `2px solid ${colors.grey33}`,
          }}
          title="Callee Avatar"
        >
          {stringAvatarProspect(callee)}
        </Avatar>

        {callee.website && (
          <Avatar
            sx={{
              width: 32,
              height: 32,
              position: 'absolute',
              bottom: -4,
              right: -4,
              color: colors.primary,
              backgroundColor: colors.primaryLight,
              fontSize: 14,
              boxShadow: `0 0 0 1px ${colors.grey33}, 0 0 0 2px white`,
            }}
            src={getImageFromUrl(callee.website, null)}
            title="Callee Website Avatar"
          >
            {callee.website}
          </Avatar>
        )}
      </div>

      <p className="font-semibold mt-1.5">
        {fullName(callee.firstName, callee.lastName)}
      </p>
      <p className="mt-1">{callee.phoneNumber}</p>
      <p className="mt-2.5 text-xs text-gray-700">{callStatusText}</p>
    </div>
  );
};
